// TODO- old file need to delete when PRD-113 released
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useFlags } from "launchdarkly-react-client-sdk";

import { usePermissions } from "components/Hook";
import GreetingHeader from "components/GreetingHeader/GreetingHeader";
import ClockInCard from "components/CheckInCheckOut/ClockInCard";
import ClockInBlockedCard from "components/CheckInCheckOut/ClockInBlockedCard";
import PayrollBar from "components/Screens/DashBoard/EmployeeDashboardV2/PayrollHistory/PayrollBar";
import PayrollStubs from "components/Screens/DashBoard/EmployeeDashboardV2/PayrollHistory/PayrollStubs";
import EmployeePeersCom from "components/Screens/DashBoard/EmployeeDashboardV2/EmployeePeers/EmployeePeers";
import PageLoader from "components/common/PageLoader";
import Notifications from "components/Screens/DashBoard/CustomerDashBoardV2/Notifications";

import { getEmployeeDetails } from "selectors/employee";

import { GetEmployeeById } from "store/actions/EmployeePortal/GetEmployeeDetials";
import { employeeSalaryDetails } from "store/actions/Workforce/EmployeeDetils/SalaryDetails";
import { employeeSalaryInfo } from "store/actions/Workforce/EmployeeDetils/SalaryInfo";
import { getEmployeePaySlips } from "services/BambooHrTabs/salarydetails";
import { getAttendanceDetails } from "services/CheckInCheckOut/CheckInAndBreaks";
import { showSnackbar } from "store/actions/Utility";

import "./index.css";

function EmployeeDashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { inAppNotifications, checkinCheckout } = useFlags();
  const { loggedInUser } = usePermissions();

  const [payrollRecord, setPayrollRecord] = useState();
  const [showBlockedCard, setShowBlockedCard] = useState(false);
  const [blockedShiftData, setBlockedShiftData] = useState(null);
  const [isLoadingAttendance, setIsLoadingAttendance] = useState(false);

  const userId = loggedInUser?.userId;
  const salaryInfo = useSelector((state) => state.SalaryInfo);
  const employeeDetails = useSelector(getEmployeeDetails);

  const timeoffCountry = employeeDetails?.timeoffCountry;

  const loadingEmployeeSalaryDetils = useSelector((state) => state.EmployeeSalaryDetails.loadingEmployeeSalaryDetils);
  const isLoadingEmployeeDetails = useSelector((state) => state.GetEmployeeDetials.isLoadingEmployeeDetails);
  const loadingEmployeeSalaryInfo = useSelector((state) => state.SalaryInfo.loadingEmployeeSalaryInfo);

  const isPeruEmployee = timeoffCountry === "Peru";

  useEffect(() => {
    dispatch(
      employeeSalaryDetails({
        request: `employee/${loggedInUser.userId}/payroll?${new URLSearchParams({
          orderBy: JSON.stringify({
            field: "paymentDate",
            direction: "asc",
          }),
        })}`,
      })
    );

    dispatch(
      GetEmployeeById({
        employeeId: loggedInUser?.userId,
      })
    );

    if (!Object.keys(salaryInfo.employeeSalaryInfo).length) {
      dispatch(
        employeeSalaryInfo({
          request: `employee/${loggedInUser.userId}/salary`,
        })
      );
    }
    if (localStorage.payoneerCode) {
      navigate("/main/edge-wallet");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchPaySlips = async () => {
      try {
        const currentYear = new Date().getFullYear().toString();
        const data = await getEmployeePaySlips(loggedInUser?.userId, currentYear);
        if (data?.ok) {
          setPayrollRecord(data);
        }
      } catch (error) {
        dispatch(showSnackbar({ dispatch, type: "error", message: "Failed to fetch pay slips" }));
      }
    };

    fetchPaySlips();
  }, [loggedInUser?.userId, dispatch]);

  const fetchAttendance = useCallback(async () => {
    if (!userId) {
      setIsLoadingAttendance(false);
      return;
    }

    setIsLoadingAttendance(true);
    try {
      const data = await getAttendanceDetails(userId);

      // Check for upcoming shift, holiday, leave, or if current time is before shift start
      const upcomingShift = data?.upcomingShift || data?.attendanceDetails?.upcomingShift;
      const todayStatus = data?.todayStatus || data?.attendanceDetails?.todayStatus;
      const isClockInAllowed = todayStatus?.isClockInAllowedToday ?? true;
      const todayType = todayStatus?.type;
      const todayLeaveName = todayStatus?.name?.toLowerCase();
      const isClockedIn = todayStatus?.isClockedIn || false;

      const schedule = data?.schedule || data?.attendanceDetails?.schedule;

      let shouldShowBlockedCard = false;
      let shiftData = null;

      // If user is clocked in, don't show blocked card - show ClockInCard instead
      if (isClockedIn) {
        shouldShowBlockedCard = false;
        shiftData = null;
      }
      // Holiday
      else if (!isClockInAllowed && todayType === "holiday") {
        shouldShowBlockedCard = true;
        shiftData = {
          type: "holiday",
          mainHeading: "Out of office",
          subHeading: "You are on holiday today",
        };
      }
      // Leave (any leave type that's not holiday or workDay)
      else if (!isClockInAllowed && todayType && todayType !== "holiday" && todayType !== "workDay") {
        shouldShowBlockedCard = true;
        shiftData = {
          type: "leave",
          mainHeading: "Out of office",
          subHeading: `You are out on ${todayLeaveName} leave.`,
          leaveType: todayType,
        };
      }
      // Upcoming shift (future date) - only show if upcomingShift exists
      else if (upcomingShift && schedule) {
        const [startHours, startMinutes] = schedule.startTime.split(":").map(Number);
        const [endHours, endMinutes] = schedule.endTime.split(":").map(Number);

        const shiftDate = new Date(upcomingShift);
        const startTime = new Date(shiftDate);
        startTime.setHours(startHours, startMinutes, 0, 0);

        const endTime = new Date(shiftDate);
        endTime.setHours(endHours, endMinutes, 0, 0);

        shouldShowBlockedCard = true;
        shiftData = {
          type: "upcomingShift",
          date: shiftDate,
          startTime,
          endTime,
        };
      }
      // Today is allowed but current time is before shift start time OR after shift end time
      else if (isClockInAllowed && schedule) {
        const [startHours, startMinutes] = schedule.startTime.split(":").map(Number);
        const [endHours, endMinutes] = schedule.endTime.split(":").map(Number);

        const now = new Date();
        const startTime = new Date();
        startTime.setHours(startHours, startMinutes, 0, 0);

        const endTime = new Date();
        endTime.setHours(endHours, endMinutes, 0, 0);

        // Calculate early clock-in time (3 hours before shift start, but not before midnight)
        const earlyClockInTime = new Date();
        const earlyClockInHours = startHours >= 3 ? startHours - 3 : 0;
        const earlyClockInMinutes = startHours >= 3 ? startMinutes : 0;
        earlyClockInTime.setHours(earlyClockInHours, earlyClockInMinutes, 0, 0);

        // Detect overnight shift: end time is less than start time
        const isOvernightShift = endHours < startHours || (endHours === startHours && endMinutes < startMinutes);

        if (isOvernightShift) {
          // For overnight shifts (e.g., 18:00 - 02:00)
          // Shift spans two days: today 18:00 to tomorrow 02:00

          if (now >= earlyClockInTime) {
            // At or after early clock-in time (3 hours before shift) - allow clock-in
            shouldShowBlockedCard = false;
          } else if (now < endTime) {
            // Before shift end time (between midnight and 02:00 for 18:00-02:00 shift) - within shift hours, allow clock-in
            shouldShowBlockedCard = false;
          } else {
            // After shift end time but before early clock-in time - show blocked card
            shouldShowBlockedCard = true;
            const displayEndTime = new Date(endTime);
            displayEndTime.setDate(displayEndTime.getDate() + 1);
            shiftData = {
              type: "beforeShiftStart",
              date: new Date(),
              startTime,
              endTime: displayEndTime,
            };
          }
        } else if (now < earlyClockInTime) {
          // Regular shift (not overnight, e.g., 09:00 - 17:00)
          // Before early clock-in time (3 hours before shift) - show today's shift
          shouldShowBlockedCard = true;
          shiftData = {
            type: "beforeShiftStart",
            date: new Date(),
            startTime,
            endTime,
          };
        } else if (now > endTime) {
          // After shift ends - show tomorrow's shift
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);

          const tomorrowStartTime = new Date(tomorrow);
          tomorrowStartTime.setHours(startHours, startMinutes, 0, 0);

          const tomorrowEndTime = new Date(tomorrow);
          tomorrowEndTime.setHours(endHours, endMinutes, 0, 0);

          shouldShowBlockedCard = true;
          shiftData = {
            type: "afterShiftEnd",
            date: tomorrow,
            startTime: tomorrowStartTime,
            endTime: tomorrowEndTime,
          };
        }
        // else: within early clock-in window or shift hours, allow clock-in
      }

      setShowBlockedCard(shouldShowBlockedCard);
      setBlockedShiftData(shiftData);
    } catch (error) {
      // Silently handle error - blocked card won't show if fetch fails
    } finally {
      setIsLoadingAttendance(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchAttendance();
  }, [fetchAttendance]);

  const handleShiftConfirm = async () => {
    await fetchAttendance();
  };

  const handleAttendanceUpdate = () => fetchAttendance();

  const handleViewTimesheet = () => {
    navigate("/main/timesheet");
  };

  const formatShiftDate = (date) => {
    if (!date) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTime = (date) => {
    if (!date) return "";
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  return (
    <>
      {isLoadingAttendance ||
      isLoadingEmployeeDetails == true ||
      loadingEmployeeSalaryDetils == true ||
      loadingEmployeeSalaryInfo == true ? (
        <PageLoader />
      ) : null}
      <div className="ep-dashboard">
        <Grid
          container
          rowSpacing={3}
          sx={{
            mt: 0,
            background: checkinCheckout ? "#FFFFFF" : "#FBFAFF",
            width: inAppNotifications ? "100%" : "calc(100% - 328px)",
            display: "flex",
            flexDirection: "column",
            gap: "0px"
          }}>
          <GreetingHeader isEmployee />
          {checkinCheckout && isPeruEmployee && !isLoadingAttendance && (
            <div className="ep-clock-in-wrapper">
              {showBlockedCard && blockedShiftData ? (
                <div className="clock-in-card clock-in-card--blocked">
                  {blockedShiftData.type === "holiday" || blockedShiftData.type === "leave" ? (
                    <ClockInBlockedCard
                      mainHeading={blockedShiftData.mainHeading}
                      subHeading={blockedShiftData.subHeading}
                      action2={{
                        label: "No clock-in required",
                        onClick: () => {},
                        variant: "contained",
                        color: "secondary",
                        size: "medium",
                        disabled: true,
                      }}
                    />
                  ) : (
                    <ClockInBlockedCard
                      mainHeading={`Upcoming shift time on ${formatShiftDate(blockedShiftData.date)}`}
                      subHeading={`${formatTime(blockedShiftData.startTime)} - ${formatTime(blockedShiftData.endTime)}`}
                      subText="local time"
                      action1={{
                        label: "View Timesheet",
                        onClick: handleViewTimesheet,
                        variant: "contained",
                        color: "inherit-text",
                        size: "medium",
                        disabled: false,
                      }}
                      action2={{
                        label: "No clock in allowed",
                        onClick: () => {},
                        disabled: true,
                        endIcon: <InfoOutlinedIcon />,
                        tooltip: {
                          content:
                            "You are allowed to clock in 3 hours before your shift starts. In case you want changes to your shift, contact HR directly.",
                          direction: "bottom",
                        },
                      }}
                    />
                  )}
                </div>
              ) : (
                <ClockInCard onShiftConfirm={handleShiftConfirm} onAttendanceUpdate={handleAttendanceUpdate} />
              )}
            </div>
          )}
          <div className="ep-payroll-widget">
            <div className="ep-payroll-h1">
              <div className="ep-payroll-h1a">Payroll History</div>
              <div
                className="ep-payroll-h1b"
                id="view-details-payroll-history"
                onClick={() => navigate("/main/paystubs")}
              >
                View Details
              </div>
            </div>
            {payrollRecord?.payload?.rows?.length > 0 && (
              <div className="ep-payroll-data-div">
                <PayrollBar payrollData={payrollRecord} />
                <PayrollStubs payrollData={payrollRecord} />
              </div>
            )}
          </div>
          <>
            <div className="ep-payroll-h1">
              <div className="ep-payroll-h1a">Peers</div>
              <div className="ep-payroll-h1b" id="view-all-peers" onClick={() => navigate("/main/peers")}>
                View All
              </div>
            </div>
            <EmployeePeersCom />
          </>
        </Grid>

        {!inAppNotifications && (
          <Grid
            sx={{
              width: "328px",
              height: "calc(100vh - 46px)",
              position: "fixed",
              background: "#F5F5FF",
              right: 0,
            }}
          >
            <Notifications isEmployee />
          </Grid>
        )}
      </div>
    </>
  );
}

export default EmployeeDashboard;
